module.exports = __webpack_public_path__ + "img/community-grid.svg";